// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"8b15a5d3","554":"7a0b6e62","601":"954ab2b9","604":"609a39c1","618":"2d89129e","629":"8b9d3a75","749":"5d079cb9","787":"5946ce84","912":"342380b7","990":"e8827934"}[chunkId] + ".chunk.js";
};